/*
 * 机器生成，不要手改。改动请编辑 scripts/make_symptom_crops.py 后重跑：
 *   python3.11 scripts/make_symptom_crops.py
 *
 * 来源：scene_gen4_back.png（Asterove_yeoui 里那条降级链的第 4 代），只裁剪与最近邻放大。
 * 生成时这张图的实测：格子纹高出周围 4.591 倍、格眼
 * 2.0 像素；鳞片 6 处窗口被判定，最花那处颗粒占
 * 23.6%；叠瓦 13.0%（45/345 块）。
 */
export type SymptomEg = {
  src: string
  /** 同一块画面提高对比度之后。只有格子纹有：它原样就是看不见的。 */
  boostSrc?: string
  /** 原图上裁下来的像素尺寸。 */
  crop: [number, number]
  /** 文件里放大了几倍（页面上再按卡片宽度缩，所以图注只说「原像素的几倍」不合适）。 */
  zoom: number
  /** 提对比度的倍数，以及原始幅度有几个色阶。 */
  boost?: number
  levels?: number
  /** 这一块的实测值，写进图注，保证图与数出自同一次运行。 */
  reading: string
}

export const SYMPTOM_EG: Record<'lattice' | 'granule' | 'scale', SymptomEg> = {
  lattice: {
    src: '/img/eg-lattice.png',
    boostSrc: '/img/eg-lattice-boost.png',
    crop: [30, 41],
    zoom: 8,
    boost: 23,
    levels: 2.6,
    reading: '格眼 2.0 像素，高出周围 4.591 倍',
  },
  granule: {
    src: '/img/eg-granule.png',
    crop: [96, 64],
    zoom: 6,
    reading: '这一处颗粒占了 23.6%',
  },
  scale: {
    src: '/img/eg-scale.png',
    crop: [150, 100],
    zoom: 4,
    reading: '整张图 13.0% 的方块长着这种鳞',
  },
}
